export const isValidLink = (link?: string) => {
  if (!link) return false;
  const linkRegex = /^https:\/{2}.*\..*$/g;
  return linkRegex.test(link);
};

export const getTaxDocumentText = (documentCountry?: string) => {
  if (documentCountry === 'México') return 'Constancia de situación fiscal';
  if (documentCountry === 'Colombia') return 'Documento del RUT';
  if (documentCountry === 'Uruguay') return 'Estatuto (opcional)';
  return 'Documento fiscal de la empresa';
};

export const isEmailValid = (email: string) => {
  const regex =
    /^(([^<>()[\].,;:\s@áéíóúÁÉÍÓÚüÜñ"]+(\.[^<>()[\].,;:\s@áéíóúÁÉÍÓÚüÜñ"]+)*)|(".+"))@(([^<>()[\].,;:\s@áéíóúÁÉÍÓÚüÜñ"]+\.)+[^<>()[\].,;:\s@áéíóúÁÉÍÓÚüÜñ"]{2,})$/i;
  return regex.test(email);
};

export const getAddressErrorText = (
  selectedCountryCode?: string,
  selectedCountryName?: string,
  addressCountryCode?: string
) => {
  if (!selectedCountryCode || !selectedCountryName || !addressCountryCode) return;
  if (selectedCountryCode !== addressCountryCode)
    return `Esta dirección no pertenece a ${selectedCountryName || 'este país'}`;
  return;
};

export const isPhoneValid = (phone?: string) => /^[0-9]{6,13}$/.test(phone || '');
